import { Badge, Center, VStack } from "@chakra-ui/react";
import { useAppConfig } from "../hooks/useAppConfig";
import { useUserStore } from "../stores/userStore";

type BadgeCreditProps = {
  credit100: number;
  credit51c3: number;
  buy?: {
    buyCredit51c3: boolean;
    buyCredit100: boolean;
  };
};


export const BadgeCredit = ({
  credit100,
  credit51c3,
  buy,
}: BadgeCreditProps) => {
  const { primaryColor, secondaryColor } = useAppConfig();

  const { user } = useUserStore();
  
  return (
    <VStack>
      <Center>
        <Badge
          borderRadius="10px"
          bgColor="gray.200"
          textColor={primaryColor}
          margin="0.5em"
        >
          Credito Buoni {user.credit51c3} €
        </Badge>
        <Badge
          borderRadius="10px"
          bgColor={primaryColor}
          textColor={"#fff"}
          margin="0.5em"
        >
          Credito Residuo {user.credit100 + user.credit51c3} €
        </Badge>
      </Center>
      <Center>
        {buy?.buyCredit51c3 && `Puoi usare il tuo credito buoni (art51c3)`}
        {buy?.buyCredit100 &&
          `Puoi usare il tuo credito residuo`}
      </Center>
    </VStack>
  );
};
